/* Sop. Essential · Configurador Kit AM6 · parte 1 de 4: estado y validación (vanilla, sin dependencias)
 * Sección: sections/sop-kit-configurator.liquid
 * Los nombres de PROPS son los que llegan al pedido. Si cambias alguno,
 * actualiza también el proceso que lee los pedidos.
 */
(function () {
  'use strict';

  var PROPS = {
    design: '1. Elige el diseño',
    pmodel: 'Modelo piñón',
    top: '2. Logo (superior)',
    center: '3. Logo/texto (centro)',
    bottom: '4. Logo (inferior)',
    base: '5. Color Principal',
    det: '6. Color detalles',
    let: '7. Color Letras',
    pinon: 'Número/logo (Piñon)',
    ptype: 'Tipo piñón',
    igOn: '¿Quieres Instagram en la tapa?',
    igTapa: 'Instagram en la tapa',
    ig: 'Contacto (Instagram o WhatsApp)',
    photo: 'Foto de tu moto',
    notes: 'Comentarios extra',
    extraNote: 'Personalización',
    source: '_Configurador'
  };
  var SOURCE = 'kit-am6-v2';
  var STORE_KEY = 'sop-kit-am6-v2';
  var MAX_PHOTO = 20 * 1024 * 1024;
  var STEPS = 6;
  var STEP_NAMES = { 1: 'Tapa', 2: 'Piñón', 3: 'Colores', 4: 'Logos', 5: 'Instagram', 6: 'Revisa' };
  var IG_RE = /^[A-Za-z0-9._]{1,30}$/;
  var PHONE_RE = /^\+?[0-9][0-9 ]{7,16}$/;
  var DEFAULT_HEX = { base: '#0E0E10', det: '#E0282E', let: '#F5F4F0' };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }
  function hslHex(h, s, l) {
    s /= 100; l /= 100;
    var k = function (n) { return (n + h / 30) % 12; };
    var a = s * Math.min(l, 1 - l);
    var f = function (n) {
      var v = l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
      return ('0' + Math.round(v * 255).toString(16)).slice(-2);
    };
    return ('#' + f(0) + f(8) + f(4)).toUpperCase();
  }
  function storeGet() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function storeSet(v) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) { /* modo privado */ }
  }
  function storeClear() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) { /* nada */ }
  }
  function b64encode(obj) {
    var bytes = new TextEncoder().encode(JSON.stringify(obj));
    var bin = '';
    bytes.forEach(function (b) { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64decode(str) {
    var bin = atob(str.replace(/-/g, '+').replace(/_/g, '/'));
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  function Kit(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-sk-data]').textContent);
    this.uid = 'sk' + String(this.data.sectionId).replace(/[^a-z0-9]/gi, '');
    this.logos = String(this.data.logos || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    this.step = 1;
    this.tried = {};
    this.photo = null;
    this.pcache = {};
    var v = this.variantById(this.data.initialVariant) || this.data.variants[0];
    this.state = {
      design: '', pmodel: '', ptype: '', pnum: '', ptext: '', plogo: null,
      base: null, det: null, let: null, opts: v.options.slice(),
      top: null, center: null, bottom: null,
      igOn: '', igTapa: '', igSame: true, ig: '', notes: ''
    };
    this.restore();
    this.bind();
    this.syncInputs();
    this.render();
    this.showStep(1, false);
    this.loadThumbs();
  }

  Kit.prototype.$ = function (sel) { return this.root.querySelector(sel); };
  Kit.prototype.$$ = function (sel) { return Array.prototype.slice.call(this.root.querySelectorAll(sel)); };

  Kit.prototype.variantById = function (id) {
    return this.data.variants.find(function (v) { return v.id === id; });
  };
  Kit.prototype.variantFor = function (opts) {
    return this.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  };
  Kit.prototype.currentVariant = function () {
    return this.variantFor(this.state.opts) || this.data.variants[0];
  };
  Kit.prototype.designObj = function () {
    var name = this.state.design;
    return this.data.designs.find(function (d) { return d.name === name; });
  };
  Kit.prototype.pinonIndex = function () {
    var name = this.state.pmodel;
    var i = this.data.pinones.findIndex(function (p) { return p.name === name; });
    return i < 0 ? 0 : i;
  };

  // Valor que llega al pedido para cada color
  Kit.prototype.colorValue = function (key) {
    var c = this.state[key];
    if (!c) return '';
    if (!c.custom) return c.name;
    var ref = (c.ref || '').trim();
    return 'Personalizado ' + c.hex + (ref ? ' (' + ref + ')' : '');
  };
  Kit.prototype.hex = function (k) {
    var c = this.state[k];
    return (c && c.hex) || DEFAULT_HEX[k];
  };
  // Logo/texto de la tapa: "A buscar: …" cuando el cliente pide uno que no está
  Kit.prototype.slotValue = function (key) {
    var s = this.state[key];
    if (!s || !s.value || !String(s.value).trim()) return '';
    return (s.type === 'req' ? 'A buscar: ' : '') + String(s.value).trim();
  };
  Kit.prototype.pinonEntry = function () {
    var s = this.state;
    if (s.ptype === 'num' && s.pnum.trim()) return { kind: 'Número', value: s.pnum.trim(), show: s.pnum.trim() };
    if (s.ptype === 'text' && s.ptext.trim()) return { kind: 'Texto', value: s.ptext.trim(), show: s.ptext.trim() };
    if (s.ptype === 'logo' && s.plogo && s.plogo.value) {
      return s.plogo.type === 'req'
        ? { kind: 'Dibujo o logo a buscar', value: 'A buscar: ' + s.plogo.value, show: '?' , logo: null }
        : { kind: 'Logo', value: s.plogo.value, show: s.plogo.value, logo: s.plogo.value };
    }
    return null;
  };
  Kit.prototype.clean = function (v) {
    return (v || '').trim().replace(/^@+/, '');
  };
  Kit.prototype.igContact = function () {
    var s = this.state;
    return s.igOn === 'SÍ' && s.igSame ? this.clean(s.igTapa) : this.clean(s.ig);
  };
  // El contacto puede ser un @ de Instagram o un móvil (WhatsApp)
  Kit.prototype.contactOut = function () {
    var c = this.igContact();
    return !c ? '' : PHONE_RE.test(c) ? 'WhatsApp ' + c : '@' + c;
  };

  Kit.prototype.missing = function () {
    var s = this.state, out = [];
    function m(step, key, label) { out.push({ step: step, key: key, label: label }); }
    if (!s.design) m(1, 'design', 'modelo de tapa');
    if (!s.pmodel) m(2, 'pmodel', 'modelo de piñón');
    if (!this.pinonEntry()) m(2, 'pinon', 'qué lleva el piñón');
    if (!this.colorValue('base')) m(3, 'base', 'color principal');
    if (!this.colorValue('det')) m(3, 'det', 'color de detalles');
    if (!this.colorValue('let')) m(3, 'let', 'color de letras');
    if (!this.slotValue('center')) m(4, 'center', 'logo del centro');
    if (!s.igOn) m(5, 'igOn', '@ en la tapa sí o no');
    if (s.igOn === 'SÍ' && !IG_RE.test(this.clean(s.igTapa))) m(5, 'igTapa', '@ de la tapa');
    var c = this.clean(s.ig);
    if (!(s.igOn === 'SÍ' && s.igSame) && !PHONE_RE.test(c) && !IG_RE.test(c)) m(5, 'ig', 'tu Instagram o móvil');
    return out;
  };
  Kit.prototype.stepMissing = function (n) {
    return this.missing().filter(function (x) { return x.step === n; });
  };

  Kit.prototype.save = function () {
    storeSet({ s: this.state, t: Date.now() });
  };
  Kit.prototype.restore = function () {
    var saved = null;
    try {
      var p = new URLSearchParams(location.search).get('kit');
      if (p) saved = { s: b64decode(p) };
    } catch (e) { saved = null; }
    if (!saved) saved = storeGet();
    if (!saved || !saved.s) return;
    var s = saved.s, st = this.state, d = this.data;
    function str(v, n) { return typeof v === 'string' ? v.slice(0, n) : ''; }
    function slot(v) {
      return v && v.value ? { type: ['logo', 'text', 'req'].indexOf(v.type) > -1 ? v.type : 'text', value: str(v.value, 40) } : null;
    }
    if (d.designs.some(function (x) { return x.name === s.design; })) st.design = s.design;
    if (d.pinones.some(function (x) { return x.name === s.pmodel; })) st.pmodel = s.pmodel;
    if (['num', 'text', 'logo'].indexOf(s.ptype) > -1) st.ptype = s.ptype;
    st.pnum = str(s.pnum, 6);
    st.ptext = str(s.ptext, 6);
    st.plogo = slot(s.plogo);
    ['base', 'det', 'let'].forEach(function (k) {
      var c = s[k];
      if (!c || typeof c.name !== 'string') return;
      st[k] = { name: str(c.name, 30), hex: /^#[0-9A-F]{6}$/i.test(c.hex) ? c.hex : null, custom: !!c.custom,
        h: +c.h || 0, s: c.s == null ? 80 : +c.s, l: c.l == null ? 45 : +c.l, ref: str(c.ref, 30) };
    });
    if (Array.isArray(s.opts) && this.variantFor(s.opts)) st.opts = s.opts.slice();
    ['top', 'center', 'bottom'].forEach(function (k) { st[k] = slot(s[k]); });
    if (s.igOn === 'SÍ' || s.igOn === 'NO') st.igOn = s.igOn;
    st.igTapa = str(s.igTapa, 31);
    st.igSame = s.igSame !== false;
    st.ig = str(s.ig, 31);
    st.notes = str(s.notes, 500);
  };

  window.SopKit = {
    Kit: Kit, PROPS: PROPS, SOURCE: SOURCE, MAX_PHOTO: MAX_PHOTO, STEPS: STEPS, STEP_NAMES: STEP_NAMES,
    IG_RE: IG_RE, DEFAULT_HEX: DEFAULT_HEX, esc: esc, fmt: fmt, hslHex: hslHex, storeClear: storeClear, b64encode: b64encode
  };
})();